import { View, Text } from "react-native";
import { CircleIcon, Icon } from "ui/gluestack/icon";

export function RenderInfoItem(value: string | number, isLast: boolean) {
  return (
    <View className="flex flex-row items-center gap-x-2 text-wrap">
      <Text className="text-sm text-typography-600 shrink">{value}</Text>
      {!isLast && (
        <Icon as={CircleIcon} className="text-gray-300 w-2 h-2 fill-gray-300" />
      )}
    </View>
  );
}
